import React from "react";
import { Star } from "lucide-react";

const ITEMS = [
    "Publicidad",
    "Marketing",
    "Diseño",
    "Inteligencia Artificial",
    "Branding",
    "Espectaculares",
    "Medios",
    "Relaciones Públicas",
];

export default function Marquee() {
    const row = [...ITEMS, ...ITEMS];
    return (
        <section
            data-testid="marquee-section"
            aria-label="Lista de capacidades"
            className="bg-teal border-y-4 border-navy overflow-hidden py-5"
        >
            <div className="flex w-max animate-marquee gap-12 items-center pr-12">
                {row.map((w, i) => (
                    <div key={i} className="flex items-center gap-12">
                        <span className="font-heading text-cream text-3xl md:text-5xl uppercase whitespace-nowrap">
                            {w}
                        </span>
                        <Star
                            size={28}
                            className="text-gold shrink-0"
                            strokeWidth={2.5}
                        />
                    </div>
                ))}
            </div>
        </section>
    );
}
